<div class="section-wrapper" style="padding: 1em;">
    @if (show) {
    @if(reportType == 'SalesReport') {
    <div class="alert">
        <strong>Note:</strong> Real-time data for confirmed sales may vary.
        Kindly refer to the offline reports for accurate figures.
    </div>
    }

    <cx-datagrid (onPageChange)="onPageChange($event)" (onPageSizeChange)="onPageSizeChange($event)" 
        [pagingConfig]="pagingConfig" [title]="title" [module]="module" [fieldmodule]="fieldmodule"
        (search)="onSearch($event)" (export)="onExport($event)" (filter)="onFilter($event)"
        [inputPlaceholder]="datagridPlaceholder" (changeViews)="onViewsChange($event)"
        (createView)="onCreateView($event)" [columns]="columns" [rows]="records | paginate: pagingConfig" (save)="onGridSettingSave($event)"
        [moreOptions]="moreOptions"
        >
        <ng-template tTemplate="nodata">
            <div class="cx-datagrid-no-data">
                <div colspan="100%" align="center">
                    <i class="no-data__icon fa-light fa-chart-simple"></i>
                    No recent data at the moment
                </div>
            </div>
        </ng-template>
        <ng-template tTemplate="header" let-ctx="ctx">
            <tr>
                <ng-container *ngFor="let column of ctx.columns; let index = index;">
                    <th class="table-center" style="width: 50px;" *ngIf="column.selection" [cxColumnFrozen]="column">
                        <input [isSelectAll]="true" [cxSelectionColumn]="column" [checked]="column.selected"
                            type="checkbox" class="hand" />
                    </th>
                    <th *ngIf="!column.selection" [cxColumnSort]="column" (sort)="onSort($event)"
                        [cxColumnFrozen]="column"
                        [class.column-sorted]="column.key === sortColumn.key">
                        <div class="header-info">
                            <div>{{ column.name }}</div>
                            <i *ngIf="column.sortable" class="sort-icon fa-solid fa-arrow-up-wide-short"
                                [ngClass]="{ 'fa-arrow-down-wide-short': !column.order, 'fa-arrow-up-wide-short': column.order }"></i>
                        </div>

                        <div cxColumnResize [gridMode]="ctx.gridMode" [columnsLength]="ctx.columns"
                            [cxColumnResizeIndex]="index" class="resizer"></div>
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template tTemplate="body" let-ctx="ctx">
            <tr>
                <ng-container *ngFor="let column of ctx.columns; let index = index;">
                    <td [ngClass]="{'has-tooltip': column.frozen}" *ngIf="!column.selection" [cxColumnFrozen]="column">
                        <span
                            *ngIf="column.key != 'name' && column.key !== 'Disposition' && column.key !== 'campaignCodes' && column.key !== 'campaignNames' && column.key !== 'CallSid'">{{
                            ctx.row | cxnestedread:column }}</span>
                        <span *ngIf="column.key === 'CallSid'" [attr.data-tooltip]="ctx.row[column.key]"
                            data-tooltip-conf="bottom multiline">
                            {{ ctx.row.CallSid}}
                        </span>

                        <span *ngIf="column.key === 'Disposition'" [attr.data-tooltip]="ctx.row[column.key]"
                            data-tooltip-conf="bottom multiline">
                            {{ ctx.row.Disposition | cxsplice:0:20 }}
                        </span>

                        <span *ngIf="column.key === 'campaignCodes'" [attr.data-tooltip]="ctx.row[column.key]"
                            data-tooltip-conf="bottom multiline">
                            {{ ctx.row.campaignCodes | cxsplice:0:20 }}
                        </span>

                        <span *ngIf="column.key === 'campaignNames'" [attr.data-tooltip]="ctx.row[column.key]"
                            data-tooltip-conf="bottom multiline">
                            {{ ctx.row.campaignNames | cxsplice:0:20 }}
                        </span>

                        <span *ngIf="column.key == 'name'">{{ ctx.row.customer_info.first_name + ' ' +
                            ctx.row.customer_info.last_name }}</span>


                        <span *ngIf="column.editable" [cxEditColumn]="column" [cxEditColumnRow]="ctx.row[column.key]"
                            class="edit">
                            <i class="fa-light fa-edit"></i>
                            <!-- <fa-icon [icon]="Icons.faEdit" /> -->
                        </span>

                    </td>
                    <td class="table-center" style="width: 50px;" *ngIf="column.selection" [cxColumnFrozen]="column">
                        <input [(ngModel)]="ctx.row.selected" [checked]="column.selected || ctx.row.selected"
                            class="hand" [cxSelectionColumn]="column" [cxSelectionColumnRow]="ctx.row"
                            type="checkbox" />
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </cx-datagrid>
    }
</div>